// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";

// import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// Read from REACT_APP_FIREBASE_* so a build can target a project other than
// production; the fallbacks are the previously hardcoded `vhakachazw` values,
// so an ordinary build is byte-identical. Mirrors the provider app's
// src/lib/firebase/config.ts.
//
// `projectId` matters even against the emulator: the suite namespaces data per
// project, so a client left on `vhakachazw` reads an empty database while the
// seed scripts write to `demo-vhakacha` in the very same emulator.
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyD9av_HjviQP3gDlXH2IwS0_33LUyv17Ro",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "vhakachazw.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "vhakachazw",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "vhakachazw.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "923983595669",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:923983595669:web:ffb6179f7a9af86bcfb39c",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-3ZLCGMLX3Q"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);
// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

/**
 * Point the SDKs at the local emulator suite instead of `vhakachazw`.
 *
 * Opt in with REACT_APP_FIREBASE_USE_EMULATOR=true (`npm run dev:emulator`).
 * Off by default, so an ordinary `npm start` or `npm run build` is unchanged.
 *
 * The mirror of this lives in the provider app at src/lib/firebase/config.ts,
 * which has had it for a while. This app did not, which meant every question
 * about traveller-facing behaviour — what an itinerary looks like in a
 * destination with no restaurants, whether the interest ranking actually
 * re-orders anything — could only be answered against live production data, or
 * not at all. Ports match the `emulators` block in firebase.json.
 */
if (process.env.REACT_APP_FIREBASE_USE_EMULATOR === 'true') {
  const host = process.env.REACT_APP_FIREBASE_EMULATOR_HOST || '127.0.0.1';
  connectFirestoreEmulator(db, host, Number(process.env.REACT_APP_FIREBASE_FIRESTORE_EMULATOR_PORT || 8080));
  connectAuthEmulator(auth, `http://${host}:${Number(process.env.REACT_APP_FIREBASE_AUTH_EMULATOR_PORT || 9099)}`, {
    disableWarnings: true,
  });
  // Loud on purpose: a developer looking at an empty catalogue should know
  // immediately that they are not looking at production.
  console.warn(`[firebase] using the emulator suite at ${host} — this is NOT production data`);
}

/**
 * App Check — proves a request came from THIS app, not from a script holding
 * the API key above.
 *
 * The key is public and `listings` is `allow read: if true`, so nothing today
 * rate-limits scraping the whole catalogue or hammering the auth endpoints.
 * firestore.rules answers "who may read this", which is a different question
 * from "is this even our app asking".
 *
 * ── OFF UNLESS A SITE KEY IS SET ──────────────────────────────────────────
 *
 * No key, no App Check, no behaviour change. It ships inert.
 *
 * ── THIS APP IS THE REASON THE ORDER MATTERS ──────────────────────────────
 *
 * Enforcement is set per-product in the Firebase console and applies to the
 * whole `vhakachazw` project — which serves this PWA AND the provider console.
 * Turning it on while travellers are running a bundle without App Check locks
 * every one of them out of a live product. So:
 *
 *   1. Deploy BOTH apps with a site key set. Nothing changes for users.
 *   2. Watch console → App Check → Metrics until verified requests are ~100%.
 *      Travellers on a cached bundle show up there as outdated clients; they
 *      are the ones enforcement would break.
 *   3. Only then enforce, one product at a time.
 *
 * The mirror of this lives in vhakacha-service-provider-app at
 * src/lib/firebase/config.ts — both must ship before step 3.
 */
const appCheckSiteKey = process.env.REACT_APP_FIREBASE_APPCHECK_SITE_KEY;

if (typeof window !== 'undefined' && appCheckSiteKey) {
  // Loaded lazily so the reCAPTCHA bundle is not pulled into the main chunk
  // for the many visitors who never sign in.
  import('firebase/app-check')
    .then(({ initializeAppCheck, ReCaptchaV3Provider }) => {
      // Lets localhost attest without a real reCAPTCHA assessment. Register
      // the printed value under App Check -> Apps -> Manage debug tokens.
      // Never set this in a production build.
      const debugToken = process.env.REACT_APP_FIREBASE_APPCHECK_DEBUG_TOKEN;
      if (debugToken) {
        // Firebase reads this off `self`; on the browser main thread that is
        // `window`, and CRA's eslint bans the `self` alias outright.
        window.FIREBASE_APPCHECK_DEBUG_TOKEN = debugToken === 'true' ? true : debugToken;
      }

      initializeAppCheck(app, {
        provider: new ReCaptchaV3Provider(appCheckSiteKey),
        isTokenAutoRefreshEnabled: true,
      });
    })
    .catch((err) => {
      // Not fatal. Before enforcement this costs nothing; after it, the
      // requests fail anyway and with a clearer error than a blank page from a
      // throw during module init.
      console.error('App Check failed to initialise:', err);
    });
}


